import { logger } from '@/helpers/logger';

const EXPECTATIONS_MATCHER = new RegExp(
  '<[hp]\\d?><b>Anforderungen<\\/b><\\/[hp]\\d?>(.*?)(?=<[hp]\\d?><b>(Noch Fragen?|Zusatzinformationen))',
  's'
);

const REPLACEMENT_EXPECTATIONS = `<h2>Anforderungen</h2>`;

export const transformWorkdayHtmlExpectations = (workdayHtml: string) => {
  const [, matchedHtml = ''] = workdayHtml.match(EXPECTATIONS_MATCHER) || [];

  if (!matchedHtml) {
    logger.error('[invalid workday html (expectations) ]', { workdayHtml });
    return 'Leider gab es einen';
  }

  return REPLACEMENT_EXPECTATIONS + matchedHtml;
};
